import React, { useContext, useEffect, useState, Fragment } from 'react';
import { useParams, Link } from "react-router-dom";

import CheckboxField from '../components/CheckboxField';
import CardProfile from '../components/CardProfile';
import CourseUpdates from '../components/CourseUpdates';
import Tile from '../components/Tile';

import { AppContext } from '../../App';

const Course = (props) => {
  const { page, courses } = props;
  const { action, courseId, section } = useParams();
  const [selectedAdditionalModules, setSelectedAdditionalModules] = useState([]);
  const [course, setCourse] = useState([]);
  const [user, setUser] = useState(false)
  const [courseStudent, setCourseStudent] = useState(null);
  const [isEnrolled, setIsEnrolled] = useState(false);
  const appContext = useContext(AppContext);
  const [content, setContent] = useState(null);

  const [visibleCommitteeMembers, setVisibleCommitteeMembers] = useState(6);
  const [visibleLecturers, setVisibleLecturers] = useState(6);

  const loadMoreCommitteeMembers = () => {
    setVisibleCommitteeMembers(prevVisible => prevVisible + 6);
  };

  const loadMoreLecturers = () => {
    setVisibleLecturers(prevVisible => prevVisible + 6);
  };

  useEffect(() => {

    // Fetch logged in user
    appContext.httpClient.get({
      path: "user"
    }).then(response => {
      if (response.result) {
        console.log(response.result)
        setUser(response.result);
      }
    })

    // Fetch student's course status
    /*
    appContext.httpClient.get({
      path: "courseapplication/myapplications"
    }).then(response => {
      if (response.success && response.result) {        
        const course = response.result.find(c => c.courseId == courseId);
        const enrolledStatus = 'ENROLLED';
        console.log(course)
        if (course) {
          console.log("found course")
          if (course.statusCodeName === enrolledStatus) {
            setIsEnrolled(true);
          } else {
            setIsEnrolled(false);
          }
        } else {
          console.log("no course")
          setIsEnrolled(false);
        }
        console.log(isEnrolled)
      }
    });
    */

  }, [appContext.apiBaseUrl, courseId]);

  useEffect(() => {
    appContext.httpClient.post({
      path: "coursestudent",
      body: {
        courseId,
        userId: appContext.userId
      }
    }).then(response => {
        console.log(response)
        if (response.success && response.result) {
            setCourseStudent(response.result)
            setIsEnrolled(response.success && response.result != null);
            console.log(response.result)
        }
    });

    appContext.httpClient.get({
      path: "course/" + courseId + "/subcontent"
    })
    .then(response => {
        if (response.success && response.result) {
            console.log(response.result)
            const contentData = response.result;
            contentData.committeeMembers = contentData.committeeMembers.filter((committee, index, self) => 
              index === self.findIndex((c) => c.courseCommitteeId === committee.courseCommitteeId)
            );
            setContent(contentData)
        }
    });
  }, [appContext.apiBaseUrl, courseId]);

  const handleCheckboxChange = (module, isChecked) => {
    if (isChecked) {
        // Check if the module is already in the selectedModules array
        const isAlreadySelected = selectedAdditionalModules.some(m => m.moduleName === module.moduleName);
        
        if (!isAlreadySelected) {
            setSelectedAdditionalModules(prevModules => [...prevModules, module]);
        }
    } else {
        setSelectedAdditionalModules(prevModules => prevModules.filter(m => m.moduleName !== module.moduleName));
    }
  };

  const calculateTotal = () => {
      return selectedAdditionalModules.reduce((total, module) => total + module.price, 0).toFixed(2);
  };

  useEffect(() => {
    appContext.httpClient.get({
        path: "course/" + courseId
    }).then(response => {
        //debugger;
        console.log(response.result)
        if (response.result) {  
          console.log(response.result);
          const courseData = response.result;
          courseData.courseLogo = appContext.fileBaseUrl + courseData.courseLogo.replace(/^~/, '');
          courseData.courseBrochure = appContext.fileBaseUrl + courseData.courseBrochure.replace(/^~/, '');
          courseData.courseBrochureCoverImage = appContext.fileBaseUrl + courseData.courseBrochureCoverImage.replace(/^~/, '');
          courseData.courseHandbook = appContext.fileBaseUrl + courseData.courseHandbook.replace(/^~/, '');
          courseData.courseHandbookCoverImage = appContext.fileBaseUrl + courseData.courseHandbookCoverImage.replace(/^~/, '');
          setCourse(courseData);
        }
    });
  }, [appContext.apiBaseUrl]);

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const courseEnrollmentStartDate = new Date(course.courseEnrollmentStartDate);
  const courseEnrollmentEndDate = new Date(course.courseEnrollmentEndDate);
  const courseStartDate = new Date(course.courseStartDate);
  const courseEndDateYear1 = course.courseEndDate ? new Date(course.courseEndDate) : null;
  const courseEndDateYear2 = course.courseEndDateYear2 ? new Date(course.courseEndDateYear2) : null;

  const courseEffectiveEndDate =
    courseStudent?.yearsToComplete === 2
      ? courseEndDateYear2
      : courseEndDateYear1;

  const today = new Date();
  const firstModuleId = course.moduleGroups?.[0]?.modules?.[0]?.courseModuleId;

  console.log('courseStartDate:', courseStartDate);
  console.log('today:', today);

  const getFirstSentence = (htmlString) => {
    // Create a temporary DOM element to strip the HTML tags
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;
    const plainText = tempDiv.textContent || tempDiv.innerText || "";
    
    // Split the plain text into sentences
    const firstSentence = plainText.split('. ')[0] + '.';
    
    return firstSentence;
  };

  const renderCourseActionButton = () => {
    // Not logged in
    if (!user) {
      return (
        <a href="/account/login">
          <button
            type="submit"
            className="bg-brandDarkBlue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md self-start"
          >
            Please login to apply
          </button>
        </a>
      );
    }

    // Logged in, not enrolled
    if (!isEnrolled) {
      if (today < courseEnrollmentStartDate) {
        return (
          <button
            type="button"
            className="border border-2 border-brandDarkBlue text-brandDarkBlue font-medium py-2 px-6 rounded-md self-start cursor-default"
            style={{ border: "2px solid #172B46 !important" }}
          >
            Taking applicants from {formatDate(course.courseEnrollmentStartDate)}
          </button>
        );
      }

      if (today >= courseEnrollmentStartDate && today <= courseEnrollmentEndDate) {
        return (
          <Link to="application">
            <button
              type="submit"
              className="bg-brandRed hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md self-start"
            >
              Apply now
            </button>
          </Link>
        );
      }

      return (
        <button
          type="button"
          className="border border-2 border-brandDarkBlue text-brandDarkBlue font-medium py-2 px-6 rounded-md self-start cursor-default"
          style={{ border: "2px solid #172B46 !important" }}
        >
          Sorry, applications are now closed
        </button>
      );
    }

    // Enrolled users
    if (today < courseStartDate) {
      return (
        <button
          type="button"
          className="border border-2 border-brandDarkBlue text-brandDarkBlue font-medium py-2 px-6 rounded-md self-start cursor-default"
          style={{ border: "2px solid #172B46 !important" }}
        >
          Course starts {formatDate(course.courseStartDate)}
        </button>
      );
    }

    if (today >= courseStartDate && today <= courseEffectiveEndDate) {
      return (
        <Link to={firstModuleId ? `../course/${courseId}/module/${firstModuleId}` : ""}>
          <button
            type="submit"
            className="bg-brandRed hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md self-start"
          >
            Start
          </button>
        </Link>
      );
    }

    return (
      <button
        type="button"
        className="border border-2 border-brandDarkBlue text-brandDarkBlue font-medium py-2 px-6 rounded-md self-start cursor-default"
        style={{ border: "2px solid #172B46 !important" }}
      >
        Sorry, the course has now ended
      </button>
    );
  };



  return (
    <div>
      {/* Hero */}
      <section className="hero hero--education relative h-80 bg-gradient-to-r from-darkHero to-lightHero text-white">
        <div className="container relative z-10 flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <header className="section-header mt-auto mb-10">
            <h2 className="section-title text-4.5xl font-bold">{course.courseTitle}</h2>
          </header>
          {/* Breadcrumbs */}
          <div className="breadcrumbs mb-4">
            <ul className="flex">
              <li><Link className="white underline" to="/">Home</Link></li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><Link className="white underline" to="/education/v1">Education</Link>
              </li>
              <li className="breadcrumb-current">
                <span className="breadcrumb-seperator mx-1">\</span><span className="text-fontColor">{course.courseTitle}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex absolute z-0 top-0 left-0 right-0 bottom-0">
          <img className="object-cover lg:object-contain lg:object-right ml-auto" src="https://insol.azureedge.net/cmsstorage/insol/media/heros/hero-arrow-education.png" alt="" />
        </div>
      </section>

      {/* My Courses */}
      <section className="courses py-8 lg:py-12">
        <div className="container flex flex-col h-full gap-6 mx-auto max-w-540 md:max-w-640 lg:flex-row lg:max-w-992 xl:max-w-90rem p-4">
              <div className="flex-1">
                <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Course Overview</h1>
                <div className="course__introduction" dangerouslySetInnerHTML={{ __html: course.courseIntroduction }} />
                {courseStudent && course.courseUpdates && today >= courseStartDate && (
                  <CourseUpdates 
                    text={course.courseUpdates}
                  />
                )}
              </div>

              <aside className="flex flex-col relative lg:w-450">

                <div className="flex flex-col relative p-6 mb-6 text-white bg-cloudBlue lg:w-450">
                  {course.courseLogo && (
                    <img className="h-28 object-contain mr-auto mb-4" src={course.courseLogo} alt={course.courseTitle} />
                  )}
                  {course.courseEnrollmentStartDate && course.courseEnrollmentEndDate && (
                    <>
                    <h2 className="section-title text-xl text-brandDarkBlue font-bold mb-4">Enrolment date</h2>
                    <span className="text-brandMidBlue mb-4">{formatDate(course.courseEnrollmentStartDate)} - {formatDate(course.courseEnrollmentEndDate)}</span>
                    </>
                  )}
                  {course.courseStartDate && course.courseEffectiveEndDate && (
                    <>
                    <h2 className="section-title text-xl text-brandDarkBlue font-bold mb-4">Course date</h2>
                    <span className="text-brandMidBlue mb-4">{formatDate(course.courseStartDate)} - {formatDate(course.courseEffectiveEndDate)}</span>
                    </>
                  )}
                  {course.courseAdminName && course.courseAdminEmail && (
                    <>
                    <h2 className="section-title text-xl text-brandDarkBlue font-bold mb-4">Course contact</h2>
                    <span className="text-brandMidBlue mb-4">{course.courseAdminName} - <a className="underline" href={`mailto${course.courseAdminEmail}`}>{course.courseAdminEmail}</a></span>
                    </>
                  )}

                  {renderCourseActionButton()}

                </div>

                {!courseStudent && course.courseBrochure && (
                <div className="flex gap-6 relative p-6 text-white bg-brandGrey lg:w-450">
                  <a href={course.courseBrochure} target="_blank" className="flex-shrink-0 w-[202px] h-[285px]">
                    <img src={course.courseBrochureCoverImage} width={202} height={285} className="flex self-start" />
                  </a>
                  <div>
                    <h2 className="section-title text-xl text-brandDarkBlue font-bold mb-4">Course brochure</h2>
                    <p className="text-brandMidBlue mb-6">{course.courseBrochureSummary}</p>
                  </div>
                </div>
                )}
                {courseStudent && course.courseHandbook && (
                  today > courseStartDate ? (
                    <div className="flex gap-6 relative p-6 text-white bg-brandGrey lg:w-450">
                      <a href={course.courseHandbook} target="_blank" className="flex-shrink-0 w-[202px] h-[285px]">
                        <img src={course.courseHandbookCoverImage} width={202} height={285} className="flex self-start" />
                      </a>
                      <div>
                        <h2 className="section-title text-xl text-brandDarkBlue font-bold mb-4">Course handbook</h2>
                        <p className="text-brandMidBlue mb-6">{course.courseHandbookSummary}</p>
                      </div>
                    </div>
                    ) : (
                      <div className="flex gap-6 relative p-6 text-white bg-brandGrey lg:w-450">
                        <a href={course.courseBrochure} target="_blank" className="flex-shrink-0 w-[202px] h-[285px]">
                          <img src={course.courseBrochureCoverImage} width={202} height={285} className="flex self-start" />
                        </a>
                        <div>
                          <h2 className="section-title text-xl text-brandDarkBlue font-bold mb-4">Course brochure</h2>
                          <p className="text-brandMidBlue mb-6">{course.courseBrochureSummary}</p>
                        </div>
                      </div>
                    )
                )}

              </aside>
          </div>
      </section>

      {courseStudent && isEnrolled && today >= courseStartDate && today <= courseEffectiveEndDate && (
        <>
          <section className="courses py-8 lg:py-12">
            <header className="section__header">
              <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
                <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Compulsory modules</h1>
              </div>
            </header>
            <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
              <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                {course.allModulesRequired ? (
                    <>
                    {course?.moduleGroups?.filter(group => group.requirementCodeName === 'compulsory').map((group, index) => (
                      <React.Fragment key={index}>
                        
                        {group.modules?.map((module, moduleIndex) => (
                          <article key={moduleIndex} className="relative p-6 text-white bg-brandDarkBlue">
                            <div className="course__desc pb-6 mb-4">
                              <span>{module.requirementCodeName}</span>
                              <h1 className="course__title text-xl mb-4">{module.moduleName}</h1>
                              <span className="course__summary">{module.moduleSummary}</span>
                            </div>
                            <Link to={`../course/${courseId}/module/${module.courseModuleId}`} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
                          </article>
                        ))}
                      </React.Fragment>
                    ))}
                    </>

                  ) : (

                    <>
                    {course?.moduleGroups?.filter(group => ["compulsory", "ab-compulsory"].includes(group.requirementCodeName)).map((group, index) => (
                      <React.Fragment key={index}>
                        {group.modules
                        ?.filter(module => courseStudent?.selectedModules?.some(selected => 
                          selected.courseModuleId === module.courseModuleId && selected.isElective === false
                            )
                          )
                          .map((module, moduleIndex) => (
                          <article key={moduleIndex} className="relative p-6 text-white bg-brandDarkBlue">
                            <div className="course__desc pb-6 mb-4">
                              <h1 className="course__title text-xl mb-4">{module.moduleName}</h1>
                              <span className="course__summary">{module.moduleSummary}</span>
                            </div>
                            <Link to={`../course/${courseId}/module/${module.courseModuleId}`} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
                          </article>
                        ))}
                      </React.Fragment>
                    ))}
                    </>
                )}
              </div>
            </div>
          </section>
          {!course.allModulesRequired && (
            <>
            <section className="courses py-8 lg:py-12">
              <header className="section__header">
                <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
                  <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Elective modules</h1>
                </div>
              </header>
              <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

                  {course.allModulesRequired ? (
                    <>
                    {course?.moduleGroups?.filter(group => group.requirementCodeName === 'elective').map((group, index) => (
                      <React.Fragment key={index}>
                        {group.modules?.map((module, moduleIndex) => (
                          <article key={moduleIndex} className="relative p-6 text-white bg-brandDarkBlue">
                            <div className="course__desc pb-6 mb-4">
                              <h1 className="course__title text-xl mb-4">{module.moduleName}</h1>
                              <span className="course__summary">{module.moduleSummary}</span>
                            </div>
                            <Link to={`../course/${courseId}/module/${module.courseModuleId}`} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
                          </article>
                        ))}
                      </React.Fragment>
                    ))}
                    </>

                  ) : (

                    <>
                    {course?.moduleGroups?.filter(group => ["elective", "ab-compulsory"].includes(group.requirementCodeName)).map((group, index) => (
                      <React.Fragment key={index}>
                        {group.modules?.filter(module => courseStudent?.selectedModules?.some(selected => selected.courseModuleId === module.courseModuleId && selected.isElective === true)).map((module, moduleIndex) => (
                          <article key={moduleIndex} className="relative p-6 text-white bg-brandDarkBlue">
                            <div className="course__desc pb-6 mb-4">
                              <h1 className="course__title text-xl mb-4">{module.moduleName}</h1>
                              <span className="course__summary">{module.moduleSummary}</span>
                            </div>
                            <Link to={`../course/${courseId}/module/${module.courseModuleId}`} className="absolute top-0 right-0 bottom-0 left-0 text-0">Read more</Link>
                          </article>
                        ))}
                      </React.Fragment>
                    ))}
                    </>
                )}


                </div>
              </div>
            </section>
            {/*<section className="courses py-8 lg:py-12 bg-brandGrey">
              <header className="section__header">
                <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
                  <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Additional modules</h1>
                </div>
              </header>
              <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
                <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {course?.moduleGroups?.map((group, index) => (
                    <React.Fragment key={index}>
                      {group.modules?.map((module, moduleIndex) => (
                        <article key={moduleIndex} className="relative p-6 text-white bg-brandDarkBlue">
                          <div className="course__desc mb-6">
                            <h1 className="course__title text-xl mb-4">{module.moduleName}</h1>
                            <span className="course__summary">{module.moduleSummary}</span>
                          </div>
                          <div className="flex items-center mb-2">
                            <label className="flex items-center pr-6 mb-1">
                              <input
                                type="checkbox"
                                className="mr-2"
                                onChange={(e) => handleCheckboxChange(module, e.target.checked)}
                              />
                              Select module
                            </label>
                          </div>
                        </article>
                      ))}
                    </React.Fragment>
                  ))}
                </div>
                {selectedAdditionalModules.length > 0 && (
                  <table className="mt-6">
                    <thead>
                      <tr>
                        <th className="bg-brandDarkBlue text-white text-left py-2 px-4 border-2 border-white">Selected Additional Modules</th>
                        <th className="bg-brandDarkBlue text-white text-left py-2 px-4 border-2 border-white">Price (£) *</th>
                      </tr>
                    </thead>
                    <tbody id="options">
                      {selectedAdditionalModules.map((module, index) => (
                        <tr key={index}>
                          <td className="bg-brandMidBlue text-white text-left py-2 px-4 border-2 border-white">{module.moduleName}</td>
                          <td className="bg-brandMidBlue text-white text-left py-2 px-4 border-2 border-white">£200.00</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </section>*/}
          </>
          )}
        </>
      )}

      {content?.committeeMembers?.length > 0 && (
      <section className="courses py-8 lg:py-12">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Course Committee</h1>
            {/*<div className="section__header-row mb-6 max-w-640">
              <span className="section__header-subtitle text-brandMidBlue">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</span>
            </div>*/}
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
            {content && content.committeeMembers && content.committeeMembers.slice(0, visibleCommitteeMembers).map((committee, index) => {
              const placeholder = 'https://insol.azureedge.net/cmsstorage/insol/media/placeholders/dummy341x320.jpg';
              const committeeImage = appContext.fileBaseUrl + committee.image.replace(/^~/, '');
              return (
              <CardProfile 
                name={committee.fullName}
                jobtitle={committee.jobTitle}
                address={committee.summary}
                image={committee.image ? committeeImage : placeholder}
              />
              );
            })}
          </div>

          {content && content.committeeMembers && visibleCommitteeMembers < content.committeeMembers.length && (
            <div className="text-center mt-6">
              <button
                onClick={loadMoreCommitteeMembers}
                className="bg-brandRed hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </section>
      )}

      {content?.lecturers?.length > 0 && (
      <section className="courses py-8 lg:py-12">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Course Lecturers</h1>
            {/*<div className="section__header-row mb-6 max-w-640">
              <span className="section__header-subtitle text-brandMidBlue">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut ero labore et dolore magna aliqua.</span>
            </div>*/}
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
        <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {content && content.lecturers && content.lecturers.slice(0, visibleLecturers).map((lecturer, index) => {
              const placeholder = 'https://insol.azureedge.net/cmsstorage/insol/media/placeholders/dummy341x320.jpg';
              const lecturerImage = appContext.fileBaseUrl + lecturer.image.replace(/^~/, '');
              return (
              <CardProfile 
                name={lecturer.fullName}
                jobtitle={lecturer.jobTitle}
                address={lecturer.summary}
                image={lecturer.image ? lecturerImage : placeholder}
              />
              );
            })}
          </div>

          {content && content.lecturers && visibleLecturers < content.lecturers.length && (
            <div className="text-center mt-6">
              <button
                onClick={loadMoreLecturers}
                className="bg-brandRed hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md"
              >
                Load More
              </button>
            </div>
          )}

        </div>
      </section>
      )}

      {content?.graduateFolders?.length > 0 && (
      <section className="courses py-8 lg:py-12">
        <header className="section__header">
          <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem px-4">
            <h1 className="section-title text-2xl lg:text-4xl text-brandDarkBlue font-bold mb-6">Past Graduates</h1>
          </div>
        </header>
        <div className="container flex flex-col h-full mx-auto max-w-540 md:max-w-640 lg:max-w-992 xl:max-w-90rem p-4">
          <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

            {content && content.graduateFolders.map((graduate, index) => {
              const placeholder = 'https://insol.azureedge.net/cmsstorage/insol/media/placeholders/dummy341x288.jpg'
              return (
                <Tile 
                  title={graduate.pageTitle}
                  link={graduate.absoluteUrl}
                  image={graduate.image ? graduate.image : placeholder}
                />
              );
            })}

          </div>
        </div>
      </section>
      )}

    </div>
  );
};

export default Course;